import React, { useState } from "react";
import { InputBox, VerticalList } from "./BoardInventoryStyles";
import { InputLabel } from "../../../constants/Styles";
import Checkbox from "../../common/Checkbox";
import { Part } from "../../../reducers/models/parts";
import useUpdatePartProperties from "../../../utils/hooks/inventory/updatePartProperties";
import FlashPCBSelect from "../../common/FlashPCBSelect";
import { SingleValue } from "react-select";
import { MSLLevel } from "../../component-search/PartDrawer/Inventory/PhysicalInventory/AddNewContainer";

export default function PartPropertiesUpdate({ part }: { part: Part }) {
  const [pasteInHole, setPasteInHole] = useState<boolean>(part.paste_in_hole);
  const [cannotClean, setCannotClean] = useState<boolean>(part.cannot_clean);
  const [msl, setMSL] = useState<MSLLevel | null>(
    part.moisture_sensitivity_level,
  );
  const { updatePartProperties } = useUpdatePartProperties(part.id);

  const updatePasteInHole = (newPasteInHole: boolean) => {
    updatePartProperties({
      paste_in_hole: newPasteInHole,
      cannot_clean: cannotClean,
      moisture_sensitivity_level: msl,
    });
    setPasteInHole(newPasteInHole);
  };

  const updateCannotClean = (newCannotClean: boolean) => {
    updatePartProperties({
      paste_in_hole: pasteInHole,
      cannot_clean: newCannotClean,
      moisture_sensitivity_level: msl,
    });
    setCannotClean(newCannotClean);
  };

  const handleUpdateMSL = (
    newMSL: SingleValue<{ value: MSLLevel; label: MSLLevel }> | null,
  ) => {
    if (newMSL?.value) {
      updatePartProperties({
        paste_in_hole: pasteInHole,
        cannot_clean: cannotClean,
        moisture_sensitivity_level: newMSL.value,
      });
      setMSL(newMSL.value);
    }
  };

  return (
    <VerticalList>
      <InputLabel>Paste in hole: </InputLabel>
      <Checkbox
        checked={pasteInHole}
        onChange={() => updatePasteInHole(!pasteInHole)}
      />
      <InputLabel>Cannot clean: </InputLabel>
      <Checkbox
        checked={cannotClean}
        onChange={() => updateCannotClean(!cannotClean)}
      />
      <InputBox>
        <FlashPCBSelect
          label={"MSL"}
          value={msl ? { value: msl, label: msl } : null}
          options={Object.values(MSLLevel).map((msl) => ({
            value: msl,
            label: msl,
          }))}
          onChange={handleUpdateMSL}
        />
      </InputBox>
    </VerticalList>
  );
}
